import * as maptilersdk from '@maptiler/sdk'
import {useEffect, memo} from 'react'
import {useMap} from '../hooks/useMap'
import PropTypes from 'prop-types'

/**
 * Props for the NavigationControl component.
 * @typedef {Object} ControlPositionProps
 * @property {import('@maptiler/sdk').ControlPosition} [position] - The position on the map where the control will appear. Possible values: 'top-left', 'top-right', 'bottom-left', 'bottom-right'.
 * @typedef {import('@maptiler/sdk').NavigationControlOptions & ControlPositionProps} NavigationControlProps
 */
/**
 * A wrapper component for the maptilersdk.NavigationControl that manages the lifecycle of
 * the navigation control within the map.
 *
 * @param {NavigationControlProps}  - Additional properties to pass to the maptilersdk.NavigationControl constructor
 * @returns {null} This component doesn't render any visible elements
 */
const NavigationControl = ({position = 'top-right', ...props}) => {
  const {map} = useMap()
  useEffect(() => {
    if (!map) return

    const nav = new maptilersdk.NavigationControl(props)
    map?.addControl(nav, position)
    return () => {
      map?.removeControl(nav)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map])

  return null
}

NavigationControl.propTypes = {
  position: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
  props: PropTypes.object
}

export default memo(NavigationControl)
